<template>
	<div v-bind:class="['modal-box', {'modal-box--size-xl' : isSizeXL}]" v-if="visible">
		<spinner v-if="loading"/>
		<div v-if="!loading" class="modal-content">
			<header>
				<div class="modal-headers">
					<div class="modal-header">{{ title }}</div>
				</div>
			</header>
			<main>
				{{ message }}
				<div class="button-wrapper">
					<button class="btn btn-round btn-primary" @click="actionOK">{{ buttonsLabels.ok }}</button>
				</div>
			</main>
		</div>
	</div>
</template>

<script>

import Modal from './../../plugins/AppModalAsync';

export default {
	data() {
		return {
			loading: true,
			visible: false,
			buttonsLabels: {
				ok: this.$t(`base.modal.ok`),
			},
			size: '',
			title: '',
			message: '',
			onOK: {},
		}
	},
	computed: {
		isSizeXL() {
			return this.size === 'xl'
		}
	},
	methods: {
		actionCancel(callback = true) {
			this.visible = false
		},
		actionOK() {
			if(typeof this.onOK === 'function') {
				this.onOK()
			}
			this.actionCancel(false)
		},
		start(params) {
			this.visible = true
			this.loading = true

			this.size =  params.size || ''
			params.buttonsLabels = params.buttonsLabels || {}
			this.buttonsLabels = {
				ok: (params.buttonsLabels || {}).ok || this.$t(`base.modal.ok`)
			}
			this.onOK = params.onOK || {}
		},
		end(params) {
			this.visible = false
			this.loading = false
		},
		show(params) {
			this.title = params.title || ''
			this.message = params.message || ''
			this.loading = false
		}
	},
	beforeMount() {
		Modal.EventBus.$on('show', (params) => {
			this.show(params)
		})
		Modal.EventBus.$on('start', (params) => {
			this.start(params)
		})
		Modal.EventBus.$on('end', (params) => {
			this.end()
		})
	}
}
</script>

<style scoped>
.modal-box > .modal-content {
	max-width: 500px;
}
.modal-box.modal-box--size-xl > .modal-content {
	max-width: 800px;
}
.modal-box > .modal-content > header {
	padding: 0 20px;
	color: white;
	background: var(--main-color);
}

.modal-box > .modal-content > main {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.modal-box > .modal-content > main p:first-child {
	margin-top: 0;
}

.modal-box > .modal-content > main p {
	text-align: center;
}

.modal-box.modal-box--error > .modal-content > header {
	color: white;
	background: #FF5722;
}

.modal-box.modal-box--error > .modal-content > main {
	background: #FBE9E7;
}

.modal-box.modal-box--error > .modal-content > main .btn {
    color: #ff5622;
    background-color: #fff;
    border: 1px solid #ff5622;
}
.modal-box.modal-box--error > .modal-content > main .btn.btn-primary {
    color: white;
    background-color: #ff5622;
    border: 1px solid #ff5622;
}

.button-wrapper {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
}

.button-wrapper > .btn {
	margin: 5px 10px;
}

@media only screen and (max-width: 1025px)
{
	.modal-box > .modal-content {
		width: auto;
		height: auto;
		border-radius: var(--border-radius);
		margin: 10px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/alerts/AppModalAsync.vue